// Real device coordinates only: no IP fallback, stored position, or demo location.
export const requestDeviceLocation = () => new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
        reject(new Error('当前浏览器不支持定位，请使用支持定位的浏览器。'));
        return;
    }
    navigator.geolocation.getCurrentPosition(position => {
        const {latitude, longitude, accuracy} = position.coords;
        if (![latitude, longitude, accuracy].every(Number.isFinite) ||
            Math.abs(latitude) > 90 || Math.abs(longitude) > 180 || accuracy < 0) {
            reject(new Error('设备返回的定位数据无效，请重新定位。'));
            return;
        }
        if (accuracy > 1000) {
            reject(new Error('当前定位误差超过 1 公里，请开启精确位置权限后重试。'));
            return;
        }
        resolve({latitude, longitude, accuracy, coordinate_system: 'wgs84'});
    }, error => {
        const messages = {
            1: '未获得定位权限。请在浏览器或系统设置中允许精确定位，然后重试。',
            2: '暂时无法获取设备位置，请检查系统定位设置后重试。',
            3: '定位超时，请到信号较好的位置后重试。'
        };
        reject(new Error(messages[error.code] || '设备定位失败，请稍后重试。'));
    }, {enableHighAccuracy: true, maximumAge: 0, timeout: 15000});
});

export async function resolveServiceLocation(toolCall, apiOrigin, {requestLocation = requestDeviceLocation, fetcher = fetch} = {}) {
    const queryType = toolCall?.arguments?.query_type;
    if (toolCall?.name !== 'request_device_location' || toolCall?.arguments?.vaccine_type !== 'RSV' ||
        !['facility', 'pilot_status'].includes(queryType)) {
        throw new Error('不支持的定位请求。');
    }
    const location = await requestLocation();
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 90000);
    try {
        // The endpoint is fixed; never send coordinates to a URL from tool arguments.
        const response = await fetcher(`${apiOrigin}/api/rsv/nearbyServices`, {
            method: 'POST', credentials: 'include', signal: controller.signal,
            headers: {'Content-Type': 'application/json', Authorization: '123456'},
            body: JSON.stringify({...location, query_type: queryType, limit: 3})
        });
        if (!response.ok) throw new Error('机构查询失败，请稍后重试。');
        const payload = await response.json();
        if (payload?.type !== 'clinic_recommendation' || !Array.isArray(payload.clinics)) {
            throw new Error('机构查询结果异常，请稍后重试。');
        }
        return {...payload, vaccine_type: 'RSV', query_type: queryType};
    } catch (error) {
        if (error.name === 'AbortError') throw new Error('地图查询超时，请稍后重试。');
        throw error;
    } finally {
        clearTimeout(timer);
    }
}
